var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 33,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M54 16.851H1.26",
  stroke: "url(#arrow-left_svg__a)",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.26 16.851 16.407 1.702",
  stroke: "url(#arrow-left_svg__b)",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.26 16.851 16.407 32",
  stroke: "url(#arrow-left_svg__c)",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrow-left_svg__a",
  x1: -44.5,
  y1: 15.851,
  x2: 98,
  y2: 14.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrow-left_svg__b",
  x1: -44,
  y1: 9.277,
  x2: 99,
  y2: 9.277,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrow-left_svg__c",
  x1: -44,
  y1: 17,
  x2: 98.5,
  y2: 17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#071389"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#071389"
})))));
export { SvgArrowLeft as ReactComponent };
export default __webpack_public_path__ + "/assets/9a46032f4aa6380297d21264b8938d67.svg";